import React from "react";

const BtnPink = (props) => {
  return (
    <div className="btn-pink-Container">
      <button
        disabled={props.disabled}
        className={`btn-pink ${props.disabled ? "disabled" : ""}`}
        onClick={props.onclick}
      >
        <span className="btn-pink-text">{props.text}</span>
      </button>
    </div>
  );
};

export default BtnPink;
